import React from "react";
import { useTranslation } from "../../i18n";
import BrandLogo from "./BrandLogo";

const AuthBrand = () => {
  const { t } = useTranslation();

  return (
    <div className="mb-8 text-center">
      <div className="mb-3 flex items-center justify-center">
        <BrandLogo size={40} showWordmark variant="light" />
      </div>

      <p className="text-[14px] text-[#4b5563]">{t("authUi.brandTagline")}</p>
    </div>
  );
};

export default AuthBrand;
